import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSGroupParams,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface VipBenefit {
  title: string;
  image: CMSImageBase;
}

export interface BecomeVipSection {
  title: string;
  description: string;
}

export interface VipCardBenefitContent {
  description: string;
  descriptionSuperSpot: string;
  vipType: string;
  locked: boolean;
  lockedSuperSpot: boolean;
}

export interface VipCardBenefit {
  title: string;
  benefitContent: VipCardBenefitContent[];
}

interface TextByGroup extends CMSGroupParams {
  text: string;
}

export interface SuperSpotBannerContent {
  title: string;
  description: string;
  vipType: string;
}

export interface SuperSpotModalTitleContent {
  title: string;
  vipType: string;
}

export interface VipApi extends CMSApiBase {
  title: string;
  titleH1: string;
  vipBenefits: VipBenefit[];
  vipCardBenefits: VipCardBenefit[];
  howBecomeVip: BecomeVipSection;
  pageDescriptionV2: TextByGroup[];
  termsAndConditionsV2: TextByGroup[];
  superSpotBanners: SuperSpotBannerContent[];
  superSpotModalTitles: SuperSpotModalTitleContent[];
  missionEndedText: string;

  // TODO: rm after v2 fields are filled on prod
  pageDescription: string;
  termsAndConditions: string;
}

export const vipCMSV3 = (lang: string) =>
  request<VipApi>({ url: buildCmsUrl({ path: 'vip-v-3', lang }) });

export const vipCMSV4 = (lang: string) =>
  request<VipApi>({
    url: buildCmsUrl({
      path: 'vip-v-3',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(getResponseCamelization, getResponseCMS<VipApi>),
  });

export const vipCMS = isCMSV3 ? vipCMSV3 : vipCMSV4;
